import { useEffect, useRef, useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import constants from '../../../../../utils/constants';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { Icon } from '@iconify/react';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import CustomActivatePopup from '../../../../../common/components/customactive/CustomActivatePopup';
import './Dispatch.scss';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import AddDispatch from './AddDispatch';
import { GridCellProps } from '@mui/x-data-grid';
import constant from '../../../../../utils/constants';
import CustomDialogList from '../../../../../common/components/customdialoglist/CustomDialogList';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  deactivateDispatchData,
  deleteDispatch,
  getDispatchData
} from '../../../redux/reducer/truckManagementSlices/dispatchSlice';
import InspectionView from './InspectionView';
import CustomBreadcrumbs from '../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import { useForm } from 'react-hook-form';
import CustomSearch from '../../../../../common/components/customized/customsearch/CustomSearch';
import { useAbort, usePagination } from '../../../../../utils/commonFunctions';

export interface PaginationModel {
  page: number;
  pageSize: number;
}

const Dispatch = () => {
  const [role, setRole] = useState<string>('Add Dispatch');
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isActivate, setIsActivate] = useState<boolean>(false);
  const [filteredRow, setFilteredRow] = useState<any>();
  const isOpen = Boolean(anchorEl);
  const [view, setView] = useState<boolean>(false);
  const [viewInspection, setViewInspection] = useState<boolean>(false);
  const [isViewData, setIsViewData] = useState<any>([]);
  const [FreightsData, setFreightdata] = useState<any>([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [rowsData, setRowsData] = useState(false);
  const [label, setLabel] = useState<any>('');
  const [sortModel, setSortModel] = useState<any>([]);
  const [inputValue, setInputValue] = useState<any>('');
  const { pageSize, pageNo, pagination, setPageNo, setPageSize } = usePagination();
  const [index, setIndex] = useState(0);
  const [tablePayload, setTablePayload] = useState({
    pageNo: 1,
    pageSize: 5,
    sortColumnName: null,
    sortBy: null,
    searchInput: null,
    searchColumnName: null
  });
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const { data, isLoading, count } = useAppSelector(state => state.dispatchData);
  const { isLoading: deleteLoading, type: deleteType } = useAppSelector(
    state => state.deleteAlldispatchs
  );
  const { isLoading: deactivateLoading, type } = useAppSelector(
    state => state.deactivateDispatch
  );
  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  const { control } = useForm();

  const placeholderText = [
    'Search for Dispatch ID',
    'Search for Trailer ID',
    'Search for Vehicle ID'
  ];

  const dynamicOptions = [
    {
      id: `${inputValue}`,
      label: `Dispatch ID :${inputValue}`,
      columnName: 'dispatchId'
    },
    {
      id: `${inputValue}`,
      label: `Trailer ID :${inputValue}`,
      columnName: 'trailerId'
    },
    {
      id: `${inputValue}`,
      label: `Truck ID :${inputValue}`,
      columnName: 'vehicleId'
    }
  ];

  let columns = [
    {
      field: 'isActive',
      headerName: `Status`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ value }: GridCellProps) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    {
      field: 'dispatchId',
      headerName: `Dispatch ID`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'trailerId',
      headerName: `Trailer ID`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'vehicleId',
      headerName: `Truck ID
      `,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'loadNumber',
      headerName: `Number Of Loads`,
      flex: 1,
      minWidth: 150,
      sortable: false
    },
    {
      field: 'startDate',
      headerName: `Start Date`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'endDate',
      headerName: `End Date`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'Inspection',
      headerName: `View Inspection`,
      headerAlign: 'center',
      flex: 1,
      sortable: false,
      minWidth: 150,
      align: 'center',
      renderCell: (params: any) => (
        <Box>
          <CustomIconButton
            category={params?.row?.inspectionReport ? 'View' : 'closeView'}
            showTooltip={false}
            onClick={() => handleInspecion(params?.row)}
          />{' '}
          {''}
        </Box>
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setRole(row?.roleType);
                handleUpdate(row);
                setLabel('Update Dispatch');
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
            <MenuItem disabled={filteredRow?.isActive === 0} onClick={handleViewLoad}>
              <CustomIconButton category='View' showTooltip={false} /> {''}
              {constant.View}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={e => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setIsActivate(true);
                handleClose();
              }}
            >
              {filteredRow?.isActive === 0 ? (
                <CustomIconButton showTooltip={false} category='Active' />
              ) : (
                <CustomIconButton showTooltip={false} category='Deactive' />
              )}

              {filteredRow?.isActive === 0 ? constants.ActiveStatus : constants.Deactive}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsDelete(true);
                setMessage(`${constants.DeleteCustomer} Dispatch?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  const stopInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  };

  // handle start interval
  const startInterval = () => {
    intervalId.current = setInterval(() => {
      setIndex(prevIndex => {
        return prevIndex === placeholderText.length - 1 ? 0 : prevIndex + 1;
      });
      if (inputValue.length > 0) {
        stopInterval();
      }
    }, 2000);
  };

  // function for dynamic options
  const handleInputChange = async (event: any, newValue: string) => {
    const payload: any = {
      ...tablePayload,
      searchInput: newValue
    };
    if (!newValue) {
      await dispatch(
        getDispatchData({ ...payload, signal: createAbort().abortCall.signal })
      );
    }
    setInputValue(newValue);
    setTablePayload(payload);
    setPageNo(1);
    setPageSize(5);
  };

  // function for filter Search
  const handleSearchColumnChange = async (event: any, newValue: any) => {
    const payload = {
      ...tablePayload,
      searchColumnName: newValue?.columnName,
      searchInput: newValue?.id
    };
    setTablePayload(payload);
    await dispatch(
      getDispatchData({ ...payload, signal: createAbort().abortCall.signal })
    );
    setPageNo(1);
    setPageSize(5);
  };

  // function for normal search
  const handleSearch = async () => {
    const payload = {
      ...tablePayload,
      searchInput: inputValue
    };
    setTablePayload(payload);
    await dispatch(
      getDispatchData({ ...payload, signal: createAbort().abortCall.signal })
    );
    setPageNo(1);
    setPageSize(5);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
  };

  const handleViewClose = () => {
    setView(false);
    setDialogOpen(false);
  };

  const handleViewLoad = () => {
    setView(true);
    handleClose();
    setIsViewData(filteredRow?.loadId || ['No Data Found']);
    setFreightdata(filteredRow?.freightId || ['No Data Found']);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleInspecion = (params: any) => {
    setViewInspection(true);
    setFilteredRow(params);
  };

  const handlePagination = async (newPaginationModel: PaginationModel) => {
    if (sortModel.length > 0) {
      await dispatch(
        getDispatchData({
          ...pagination(newPaginationModel),
          ...(sortModel?.length > 0
            ? { sortBy: sortModel[0].sort, sortColumnName: sortModel[0].field }
            : []),
          signal: createAbort().abortCall.signal
        })
      );
    } else {
      await dispatch(
        getDispatchData({
          ...pagination(newPaginationModel),
          signal: createAbort().abortCall.signal
        })
      );
    }
  };

  const handleSortModelChange = async (model: any) => {
    setSortModel(model);
    const payload = {
      ...tablePayload,
      sortColumnName: (model.length > 0 && model[0].field) || null,
      sortBy: (model.length > 0 && model[0].sort.toUpperCase()) || null
    };
    setTablePayload(payload);
    await dispatch(
      getDispatchData({ ...payload, signal: createAbort().abortCall.signal })
    );
  };

  const handleDeactivate = async () => {
    if (filteredRow?.id) {
      const action1 = await dispatch(deactivateDispatchData(filteredRow?.id));
      if (deactivateDispatchData.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getDispatchData({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }

    setIsActivate(false);
  };

  const handleDelete = async () => {
    if (filteredRow?.id) {
      const action1 = await dispatch(deleteDispatch(filteredRow?.id));
      if (deleteDispatch.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getDispatchData({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }
    setIsDelete(false);
  };

  useEffect(() => {
    if (data?.length >= 0) {
      setRowsData(data);
    }
  }, [data]);

  useEffect(() => {
    dispatch(getDispatchData({ ...pagination, signal: createAbort().abortCall.signal }));
    return () => {
      createAbort().abortCall.abort();
    };
  }, []);

  // useEffect(() => {
  //   if (inputValue.length > 0) {
  //     stopInterval();
  //   }
  //   if (inputValue.length < 1) {
  //     startInterval();
  //   }
  // }, [inputValue]);

  return (
    <>
      <Box className='dispatch' sx={{ position: 'relative', top: '10px' }}>
        <Box className='dispatch-title'>
          <CustomBreadcrumbs
            itemOne={constants.Inspection}
            itemTwo='View Inspection'
            itemTwoState={viewInspection}
            setView={setViewInspection}
          />
          {!viewInspection && (
            <CustomButton
              category='Add Dispatch'
              className='saveChanges'
              onClick={() => {
                setFilteredRow(null);
                setOpen(true);
                setRole('Add Dispatch');
                setLabel('Add Dispatch');
              }}
            />
          )}
        </Box>

        <Box
          sx={{
            // position: 'absolute',
            // marginTop: '0x',
            // bottom: '80px',
            // top: '0px',
            // zIndex: 1,
            // right: '100px'
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
          className='search-dispatch'
        >
          {!viewInspection && (
            <CustomSearch
              id='searchField'
              control={control}
              name='searchField'
              options={dynamicOptions}
              // placeholder={placeholderText[index]}
              placeholder='Search for ...'
              icon={<i className='custom-icon' />}
              variant='standard'
              inputValue={inputValue}
              handleInputChange={handleInputChange}
              onChanges={handleSearchColumnChange}
              handleSearchClick={handleSearch}
              // onFocus={stopInterval}
              // onBlur={startInterval}
            />
          )}
        </Box>

        {!viewInspection && (
          <CustomDataGrid
            rows={rowsData}
            columns={columns}
            loading={isLoading}
            onSortModelChange={handleSortModelChange}
            rowCount={count}
            sortingMode='server'
            type={'logistics'}
            pageNo={pageNo}
            pageSize={pageSize}
            paginationModel={{
              page: pageNo && count ? pageNo - 1 : 0,
              pageSize: pageSize ? pageSize : 5
            }}
            onPaginationModelChange={handlePagination}
          />
        )}
      </Box>

      {open && (
        <AddDispatch
          open={open}
          setOpen={setOpen}
          roleType={role}
          label={label}
          setPageNo={setPageNo}
          setPageSize={setPageSize}
          setTablePayload={setTablePayload}
          filteredRow={filteredRow}
          setFilteredRow={setFilteredRow}
          isLoading={isLoading}
        />
      )}
      {isDelete && (
        <CustomDeletePopup
          open={isDelete}
          setOpen={setIsDelete}
          handleClose={handleClose}
          handleDelete={handleDelete}
          message={message}
          isLoading={deleteType === 'delete' && deleteLoading}
        />
      )}
      {isActivate && (
        <CustomActivatePopup
          open={isActivate}
          filteredRow={filteredRow}
          setOpen={setIsActivate}
          handleDeactivate={handleDeactivate}
          isLoading={type === 'deactivate' && deactivateLoading}
        />
      )}
      {view && (
        <CustomDialogList
          open={isDialogOpen}
          handleViewClose={handleViewClose}
          title1='List of Loads'
          title2='List of Freights'
          onClose={handleCloseDialog}
          item1={isViewData}
          item2={FreightsData}
        />
      )}
      {viewInspection && (
        <InspectionView filteredRow={filteredRow} viewInspection={viewInspection} />
      )}
    </>
  );
};

export default Dispatch;
